import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import AuthForm from '@/components/auth/AuthForm';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function ResetPassword() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return (
    <ProtectedRoute requireAuth={false}>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-md mx-auto">
          <AuthForm type="reset-password" />
        </div>
      </div>
    </ProtectedRoute>
  );
} 